import { Injectable } from '@angular/core';
import { ReleaseDto, ReleasesClient } from 'src/app/web-api-client';

@Injectable({
  providedIn: 'root'
})
export class ReleaseService {
  constructor(private service: ReleasesClient) { }

  create$ = (release: ReleaseDto) => this.service.releases_CreateRelease(release);

  releases$ = () => this.service.releases_GetReleases();

  release$ = (id: number) => this.service.releases_GetRelease(id);

  update$ = (id: number, release: ReleaseDto) => this.service.releases_UpdateRelease(id, release);

  delete$ = (id: number) => this.service.releases_DeleteRelease(id);

  latestReleases$ = () => this.service.releases_GetLatestReleases();
}
